module.exports = __webpack_public_path__ + "assets/img/banner1@3x.d3df1f2d.png";